import { render } from "./UserTooltip.vue?vue&type=template&id=08e7c966"
import script from "./UserTooltip.vue?vue&type=script&lang=js"
export * from "./UserTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/TimeTracker_1.0/TimeTracker_1.0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__